module.exports = __webpack_public_path__ + "media/images/flag_ca-cfc5dbf1e4799df64d00cbbe221af02e.png";